<template>
  <div v-show="wizard.show" class="bg-white my-3" style="border-radius: 20px; box-shadow: 0 0 5px #8ce3d6;">
    <div v-if="wizard.current_step > 0" class="d-flex align-items-center justify-content-around mb-3 p-4">
      <div @click="goto_step(1)" :style="wizard.current_step > 0 ? 'cursor: pointer !important;' : ''">
        <div>
          <img src="@/pages/gateways/components/form-wizard/assets/wallet.svg" width="64" height="64" :class="wizard.current_step > 0 ? 'filter_green' : 'filter_gray'">
        </div>
        <div class="text-center mt-2">
          <span :style="wizard.current_step > 0 ? 'color: #00bea5' :'color: #d2d2d2'">نوع درگاه</span>
        </div>
      </div>
      <div>
        <img src="@/pages/dashboard/userwizard/assets/left-arrow.svg" width="16" height="16" :class="wizard.current_step > 1 ? 'filter_green' : 'filter_gray'">
      </div>
      <div @click="goto_step(2)" :style="wizard.current_step > 1 ? 'cursor: pointer !important;' : ''">
        <div>
          <img src="@/pages/gateways/components/form-wizard/assets/shop.svg" width="64" height="64" :class="wizard.current_step > 1 ? 'filter_green' : 'filter_gray'">
        </div>
        <div class="text-center mt-2">
          <span :style="wizard.current_step > 1 ? 'color: #00bea5' :'color: #d2d2d2'">اطلاعات فروشگاه</span>
        </div>
      </div>
      <div>
        <img src="@/pages/dashboard/userwizard/assets/left-arrow.svg" width="16" height="16" :class="wizard.current_step > 2 ? 'filter_green' : 'filter_gray'">
      </div>
      <div @click="goto_step(3)" :style="wizard.current_step > 2 ? 'cursor: pointer !important;' : ''">
        <div>
          <img src="@/pages/gateways/components/form-wizard/assets/website.svg" width="64" height="64" :class="wizard.current_step > 2 ? 'filter_green' : 'filter_gray'">
        </div>
        <div class="text-center mt-2">
          <span  :style="wizard.current_step > 2 ? 'color: #00bea5' :'color: #d2d2d2'">اطلاعات درگاه</span>
        </div>
      </div>
    </div>

    <hr class="custom_hr" v-if="wizard.current_step > 0">

    <div class="p-5">
        <form @submit.prevent="submit" id="gateway_form" class="bg-white">
            <div v-show="wizard.current_step === 1">
                <gateway-type-form :wizard="wizard" :form_data="form_data"></gateway-type-form>
            </div>
            <div v-show="wizard.current_step === 2">
                <shop-info-form :wizard="wizard" :form_data="form_data"></shop-info-form>
            </div>
            <div v-show="wizard.current_step === 3">
                <gateway-info-form :wizard="wizard" :form_data="form_data"></gateway-info-form>
            </div>
        </form>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import GatewayTypeForm from "./form-wizard/gateway-type-form";
import GatewayInfoForm from "./form-wizard/gateway-info-form";
import ShopInfoForm from "./form-wizard/shop-info-form";
import {i18n} from "@/plugins/i18n";
import { userStatusStr, userStatus } from "@/constants/userStatus";
import { subcategories } from '@/constants/subcategories'
import Inputmask from 'inputmask'
import { mapGetters, mapState } from 'vuex'

export default {
  components: {
    GatewayTypeForm,
    GatewayInfoForm,
    ShopInfoForm,
  },
  props: {
    submit: {
        default: () => {},
        type: Function
    },
    form_data: {
        default() {
            return {}
        },
        type: Object
    },
    wizard: {
        default() {
            return {}
        },
        type: Object
    }
  },
  mounted() {
    this.wizard.show = true;
    this.$store.dispatch('shebaNumber/fetch')
    .finally(() => {
        Object.keys(this.sheba_numbers).map(key => {
            let number = this.sheba_numbers[key]['number'] == null ? '' : 'IR'+this.sheba_numbers[key]['number'].split('-').join('')
            this.sheba_numbers[key]['number'] = number
        })
        this.$store.dispatch('address/fetch').finally(() => {
            this.afterDispatch()
        })
    })
    
  },
  data() {
    return {
        userStatus: userStatus,
        subcategories: subcategories,
        wages: [
            {
                id: 0,
                value: this.$t('gateway.wages.from_payer')
            },
            {
                id: 100,
                value: this.$t('gateway.wages.from_me')
            },
            {
                id: 50,
                value: this.$t('gateway.wages.half')
            }
        ]
    };
  },
  computed: {
    ...mapGetters("user", [
      "is_authenticated_pending",
      "current_user"
    ]),
    ...mapGetters('address', [
        'addresses'
    ]),
    ...mapGetters('shebaNumber', [
        'sheba_numbers'
    ])
  },
  methods: {
    goto_step(selected_step) {
      if (this.wizard.navigable && (this.wizard.current_step > selected_step)) {
        this.wizard.current_step = selected_step;
      }
    },
    afterDispatch() {
      setTimeout(() => {
        $('.kt-selectpicker').selectpicker({
            size: 4,
            liveSearch: true,
            noneResultsText: i18n.t('selectpicker.none_result'),
            selectAllText: i18n.t('selectpicker.select_all'),
            noneSelectedText: i18n.t('selectpicker.nothing_selected')
        })

        document.getElementById('telephone') && Inputmask('099-99999999').mask(document.getElementById('telephone'));
      }, 1000);
    },
    selectChange(event){
        if (event.target.value == 0 || event.target.value == 100)
        this.form_data.merchant_share_percent = event.target.value
    },
  },
};
</script>

<style scoped>
.filter_green {
  filter: invert(68%) sepia(25%) saturate(7218%) hue-rotate(130deg) brightness(91%) contrast(101%);
}

.filter_gray {
  filter: invert(87%) sepia(1%) saturate(200%) hue-rotate(314deg) brightness(101%) contrast(86%);
}

.label-file {
    border: 1px solid #ccc;
    width: fit-content;
    cursor: pointer;
    min-width: 200px;
}
input[type="file"]::-webkit-file-upload-button {
    visibility: hidden;
}
</style>
